// footer accordion
if (window.matchMedia("(max-width: 760px)")) {
  document.addEventListener("DOMContentLoaded", () => {
    const linkTitle = document.querySelectorAll(".link-title");
    for (let i = 0; i < linkTitle.length; i++) {
      let titleEach = linkTitle[i];
      titleEach.addEventListener("click", () => {
        titleEach.classList.toggle("active");
      });
    }
  });
}

// Home Collections
const mediaQuery = window.matchMedia("(min-width: 641px)");
const createHomeCollectionCarousel = function (
  rootEl,
  carouselSelector,
  carouselBtnPrevSelector,
  carouselBtnNextSelector
) {
  const homeCollectionCarouselElement = rootEl.querySelector(carouselSelector);
  if (!homeCollectionCarouselElement) {
    return;
  }

  let homeCollectionCarousel = new Flickity(homeCollectionCarouselElement, {
    prevNextButtons: false,
    pageDots: false,
    wrapAround: false,
    contain: true,
    resize: true,
    cellAlign: "center",
    groupCells: 4,
  });

  // mobile init
  if (!mediaQuery.matches) {
    homeCollectionCarousel.destroy();
  }

  /*
  Buttons
   */
  const carouselPrevBtnPc = rootEl.querySelector(carouselBtnPrevSelector);
  const carouselNextBtnPc = rootEl.querySelector(carouselBtnNextSelector);

  /*
  Resize
   */
  let resizeFlag = 500;
  let timeoutID = 0;
  window.addEventListener("resize", () => {
    resizeFlag = 500;
    clearTimeout(timeoutID);

    timeoutID = setTimeout(() => {
      homeCollectionCarousel.destroy();
      if (!mediaQuery.matches) {
        return;
      }
      homeCollectionCarousel = new Flickity(homeCollectionCarouselElement, {
        prevNextButtons: false,
        pageDots: false,
        wrapAround: false,
        contain: true,
        resize: true,
        cellAlign: "center",
        groupCells: 4,
      });

      if (carouselPrevBtnPc) carouselPrevBtnPc.style.visibility = "hidden";
      if (carouselNextBtnPc) carouselNextBtnPc.style.visibility = "visible";

      homeCollectionCarousel.on("select", function () {
        const index = homeCollectionCarousel.selectedIndex;
        if (!carouselPrevBtnPc || !carouselNextBtnPc) return;
        if (index === 0) {
          carouselPrevBtnPc.style.visibility = "hidden";
        } else {
          carouselPrevBtnPc.style.visibility = "visible";
        }
        if (index === homeCollectionCarousel.slides.length - 1) {
          carouselNextBtnPc.style.visibility = "hidden";
        } else {
          carouselNextBtnPc.style.visibility = "visible";
        }
      });
    }, resizeFlag);
  });

  if (carouselPrevBtnPc) {
    carouselPrevBtnPc.addEventListener("click", function () {
      homeCollectionCarousel.previous();
    });
  }
  if (carouselNextBtnPc) {
    carouselNextBtnPc.addEventListener("click", function () {
      homeCollectionCarousel.next();
    });
  }

  /*
  Events
   */
  // Initial visibility
  if (carouselNextBtnPc && homeCollectionCarousel.slides.length <= 1) {
    carouselNextBtnPc.style.visibility = "hidden";
  }
  homeCollectionCarousel.on("select", function () {
    const index = homeCollectionCarousel.selectedIndex;
    if (!carouselPrevBtnPc || !carouselNextBtnPc) return;
    if (index === 0) {
      carouselPrevBtnPc.style.visibility = "hidden";
    } else {
      carouselPrevBtnPc.style.visibility = "visible";
    }
    if (index === homeCollectionCarousel.slides.length - 1) {
      carouselNextBtnPc.style.visibility = "hidden";
    } else {
      carouselNextBtnPc.style.visibility = "visible";
    }
  });
};

/* 2026/05/29 design update: layout handled by CSS grid/scroll, Flickity disabled for home-collection-products */
const homeCollectionCarouselRoots = [];
homeCollectionCarouselRoots.forEach((rootEl) => {
  try {
    createHomeCollectionCarousel(
      rootEl,
      ".home-collection-products-carousel",
      ".home-collection-products-carousel-button.Previous",
      ".home-collection-products-carousel-button.Next"
    );
  } catch (e) {
    console.warn("home-collection carousel init failed", e);
  }
});

// Home News
const createHomeNewsCarousel = () => {
  const homeNewsCarouselElement = document.querySelector(".home-news-articles");
  if (homeNewsCarouselElement) {
    let homeNewsCarousel = new Flickity(homeNewsCarouselElement, {
      prevNextButtons: false,
      pageDots: false,
      wrapAround: false,
      contain: true,
      cellAlign: "left",
    });

    let resizeFlag = 500;
    let timeoutID = 0;
    window.addEventListener("resize", () => {
      resizeFlag = 500;
      clearTimeout(timeoutID);

      timeoutID = setTimeout(() => {
        homeNewsCarousel.destroy();
        homeNewsCarousel = new Flickity(homeNewsCarouselElement, {
          prevNextButtons: false,
          pageDots: false,
          wrapAround: false,
          contain: true,
          cellAlign: "left",
        });

        // button reset
        prevBtnPc.style.visibility = "hidden";
        prevBtnSp.style.opacity = "0.6";
        prevBtnSp.setAttribute("disabled", "true");
        nextBtnPc.style.visibility = "visible";
        nextBtnSp.style.opacity = "1";
        nextBtnSp.removeAttribute("disabled");

        homeNewsCarousel.on("select", function () {
          let index = homeNewsCarousel.selectedIndex;
          if (index === 0) {
            prevBtnPc.style.visibility = "hidden";
            prevBtnSp.style.opacity = "0.6";
            prevBtnSp.setAttribute("disabled", "true");
          } else {
            prevBtnPc.style.visibility = "visible";
            prevBtnSp.style.opacity = "1";
            prevBtnSp.removeAttribute("disabled");
          }
          if (index === homeNewsCarousel.slides.length - 1) {
            nextBtnPc.style.visibility = "hidden";
            nextBtnSp.style.opacity = "0.6";
            nextBtnSp.setAttribute("disabled", "true");
          } else {
            nextBtnPc.style.visibility = "visible";
            nextBtnSp.style.opacity = "1";
            nextBtnSp.removeAttribute("disabled");
          }
        });
      }, resizeFlag);
    });

    /*
    Buttons
     */
    const prevBtnPc = document.querySelector(".home-news-carousel-button.Pc.Previous");
    const nextBtnPc = document.querySelector(".home-news-carousel-button.Pc.Next");
    const prevBtnSp = document.querySelector(".home-news-carousel-button.Sp.Previous");
    const nextBtnSp = document.querySelector(".home-news-carousel-button.Sp.Next");
    prevBtnPc.addEventListener("click", function () {
      homeNewsCarousel.previous();
    });
    nextBtnPc.addEventListener("click", function () {
      homeNewsCarousel.next();
    });
    prevBtnSp.addEventListener("click", function () {
      homeNewsCarousel.previous();
    });
    nextBtnSp.addEventListener("click", function () {
      homeNewsCarousel.next();
    });

    /*
    Events
     */
    homeNewsCarousel.on("select", function () {
      let index = homeNewsCarousel.selectedIndex;
      if (index === 0) {
        prevBtnPc.style.visibility = "hidden";
        prevBtnSp.style.opacity = "0.6";
        prevBtnSp.setAttribute("disabled", "true");
      } else {
        prevBtnPc.style.visibility = "visible";
        prevBtnSp.style.opacity = "1";
        prevBtnSp.removeAttribute("disabled");
      }
      if (index === homeNewsCarousel.slides.length - 1) {
        nextBtnPc.style.visibility = "hidden";
        nextBtnSp.style.opacity = "0.6";
        nextBtnSp.setAttribute("disabled", "true");
      } else {
        nextBtnPc.style.visibility = "visible";
        nextBtnSp.style.opacity = "1";
        nextBtnSp.removeAttribute("disabled");
      }
    });
  }
};
createHomeNewsCarousel();

// Flickity
const rsCarousel = document.getElementById("rs-carousel");
if (rsCarousel) {
  const flkty = new Flickity(rsCarousel, {
    cellAlign: "left",
    pageDots: false,
    contain: true,
    arrowShape: {
      x0: 30,
      x1: 60,
      y1: 30,
      x2: 65,
      y2: 30,
      x3: 35,
    },
  });
}

const body = document.querySelector("body");
const zoomFrame = document.createElement("div");
zoomFrame.setAttribute("class", "zoom-frame");
const zoomImg = document.createElement("img");
const zoomClose = document.createElement("button");
zoomClose.classList.add("RoundButton");
zoomClose.insertAdjacentHTML(
  "afterbegin",
  `<svg class="Icon Icon--close" role="presentation" viewBox="0 0 16 14"><path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path></svg>`
);
zoomFrame.appendChild(zoomImg);
zoomFrame.appendChild(zoomClose);
body.appendChild(zoomFrame);
const zoomTarget = document.querySelectorAll(".rs-carousel-img");
Array.from(zoomTarget).forEach((b) => {
  b.addEventListener("click", (e) => {
    zoomImg.src = e.target.getAttribute("src");
    zoomFrame.classList.add("active");
  });
});

zoomClose.addEventListener("click", () => {
  zoomFrame.classList.remove("active");
});

// サブスク
let items = [];
const quantityTexts = Array.from(document.querySelectorAll(".quantity-text"));
const quantityButtons = Array.from(document.querySelectorAll(".quantity-button"));
const cartUpdate = document.getElementById("cartUpdate");
const cartDisaboled = document.getElementById("cartDisaboled");
const radioInputs = Array.from(document.querySelectorAll(".selling_plan"));
if (radioInputs[0]) radioInputs[0].checked = true; // ini

const findCheckedRadio = () => radioInputs.find((radio) => radio.checked);

const setQuantityText = (id, quantity) => {
  quantityTexts.forEach((text) => {
    if (text.getAttribute("variant_id") === id) text.textContent = quantity;
  });
  quantityButtons.forEach((button) => {
    if (button.getAttribute("variant_id") === id) button.setAttribute("quantity", quantity);
  });
};

const updateItems = (action, newItem) => {
  switch (action) {
    case "add":
      if (items.find((item) => item.id === newItem.id)) {
        items.forEach((item) => {
          const quantity = Number(item.quantity) + 1;
          if (item.id === newItem.id) {
            item.quantity = quantity;
            setQuantityText(newItem.id, item.quantity);
          }
        });
      } else {
        newItem.quantity = 1;
        items.push(newItem);
        setQuantityText(newItem.id, newItem.quantity);
      }
      break;

    case "decrease":
      if (items.find((item) => item.id === newItem.id)) {
        items.forEach((item, index) => {
          const quantity = Number(item.quantity) - 1;
          if (item.id === newItem.id) {
            if (quantity <= 0) {
              items.splice(index, 1);
              setQuantityText(newItem.id, 0);
            } else {
              item.quantity = quantity;
              setQuantityText(newItem.id, item.quantity);
            }
          }
        });
      }
      break;
    default:
      break;
  }

  checkForm();
};

quantityButtons.forEach((button) => {
  const type = button.getAttribute("data-action");
  const item = {
    id: button.getAttribute("variant_id"),
    quantity: 2,
  };

  button.addEventListener("click", (e) => {
    e.preventDefault();
    if (type === "add") {
      updateItems("add", item);
    }
    if (type === "decrease") {
      updateItems("decrease", item);
    }
  });
});

if (cartUpdate) {
  cartUpdate.addEventListener("click", (e) => {
    e.preventDefault();
    document.dispatchEvent(new CustomEvent("theme:loading:start"));
    const sellingPlancheckedInput = findCheckedRadio();
    const sellingPlanAddedItems = items.map((item) => ({ ...item, selling_plan: sellingPlancheckedInput.value }));

    console.log(sellingPlanAddedItems);

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({ items: sellingPlanAddedItems }),
    })
      .then((response) => {
        document.dispatchEvent(new CustomEvent("theme:loading:end"));
        document.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {},
          })
        );
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  });
}

const checkForm = () => {
  let allQuantity = 0;
  items.forEach((item) => {
    allQuantity += item.quantity;
  });
  const length = allQuantity < 1 ? true : false;
  cartUpdate.setAttribute("data-show", !length);
  cartDisaboled.setAttribute("data-show", length);
};

function remove() {
  const cartSubscription = Array.from(document.querySelectorAll(".cartSubscription"));
  document.dispatchEvent(new CustomEvent("theme:loading:start"));
  (async () => {
    for (let i = 0; i < cartSubscription.length; i++) {
      const line = cartSubscription[i].value - i;

      await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          line: line,
          quantity: 0,
        }),
      })
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
    document.dispatchEvent(new CustomEvent("theme:loading:end"));
    document.dispatchEvent(
      new CustomEvent("product:added", {
        bubbles: true,
        detail: {},
      })
    );
  })();
}

// Product background color on product detail pages
(function () {
  var BG_HANDLES = ["m-ac-02-0700", "m-ac-01-0700", "m-ac-02-0886", "m-ac-01-0886"];
  var BG_COLOR = "#cdcdcd";
  var pathMatch = window.location.pathname.match(/\/products\/([^/?#]+)/);
  if (!pathMatch || BG_HANDLES.indexOf(pathMatch[1]) === -1) return;

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".Product__SlideItem .AspectRatio, .Product__SlideshowNavImage").forEach(function (el) {
      el.style.backgroundColor = BG_COLOR;
    });
  });
})();

// Wrap ¥ symbols in price elements with .yen span for 1pt size reduction
(function () {
  function wrapYenInPrices(root) {
    const container = root || document.body;
    const walker = document.createTreeWalker(
      container,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function (node) {
          if (!node.textContent.includes("¥")) return NodeFilter.FILTER_SKIP;
          if (node.parentElement && node.parentElement.classList.contains("yen"))
            return NodeFilter.FILTER_SKIP;
          if (
            node.parentElement &&
            node.parentElement.closest(
              ".Price, .ProductMeta__PriceList, .ProductItem__PriceList, .CartItem__PriceList, .CartItem__LinePriceList, .VariantSelector__ChoicePrice, #cart-total-price"
            )
          ) {
            return NodeFilter.FILTER_ACCEPT;
          }
          return NodeFilter.FILTER_SKIP;
        },
      }
    );

    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach(function (node) {
      const fragment = document.createDocumentFragment();
      node.textContent.split(/(¥)/).forEach(function (part) {
        if (part === "¥") {
          const span = document.createElement("span");
          span.className = "yen";
          span.textContent = "¥";
          fragment.appendChild(span);
        } else {
          fragment.appendChild(document.createTextNode(part));
        }
      });
      node.parentNode.replaceChild(fragment, node);
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    wrapYenInPrices();
  });

  document.addEventListener("cart:updated", function () {
    wrapYenInPrices();
  });
  document.addEventListener("product:added", function () {
    wrapYenInPrices();
  });
})();

/* ========================================
   Language / Country selector modal
   ======================================== */
(function () {
  var closeTimer = null;

  function getModal() {
    return document.querySelector("[data-lang-country-modal]");
  }

  function open() {
    var modal = getModal();
    if (!modal) return;
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    modal.hidden = false;
    document.body.style.overflow = "hidden";
    requestAnimationFrame(function () {
      modal.classList.add("is-open");
    });
  }

  function close() {
    var modal = getModal();
    if (!modal) return;
    modal.classList.remove("is-open");
    document.body.style.overflow = "";
    if (closeTimer) clearTimeout(closeTimer);
    closeTimer = setTimeout(function () {
      modal.hidden = true;
      closeTimer = null;
    }, 300);
  }

  // Expose for inline onclick handlers on triggers (more reliable on iOS than delegation)
  window.__openLangCountry = function () {
    var openDrawer = document.querySelector('.Drawer[aria-hidden="false"]');
    if (openDrawer) {
      var closeBtn = openDrawer.querySelector('[data-action="close-drawer"]');
      if (closeBtn) closeBtn.click();
      setTimeout(open, 50);
    } else {
      open();
    }
  };

  document.addEventListener("click", function (e) {
    var opener = e.target.closest && e.target.closest("[data-lang-country-open]");
    if (opener) {
      e.preventDefault();
      e.stopPropagation();
      // Close any open Drawer (sidebar menu / cart) first so the modal isn't hidden by it
      var openDrawer = document.querySelector('.Drawer[aria-hidden="false"]');
      if (openDrawer) {
        var closeBtn = openDrawer.querySelector('[data-action="close-drawer"]');
        if (closeBtn) closeBtn.click();
      }
      // Open modal on next tick so drawer close transitions get out of the way
      setTimeout(open, 50);
      return;
    }
    var closer = e.target.closest && e.target.closest("[data-lang-country-close]");
    if (closer) {
      var modal = getModal();
      if (modal && modal.contains(closer)) {
        e.preventDefault();
        close();
      }
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    var modal = getModal();
    if (modal && !modal.hidden) close();
  });
})();


/* 2026/06 design update: arrow navigation for home-collection scroll carousels */
(function () {
  function initHcpArrows() {
    document.querySelectorAll('.home-collection-products--scroll').forEach(function (sec) {
      var car = sec.querySelector('.home-collection-products-carousel');
      if (!car || car.dataset.hcpArrowsBound) return;
      car.dataset.hcpArrowsBound = '1';
      var prev = sec.querySelector('[data-hcp-prev]');
      var next = sec.querySelector('[data-hcp-next]');
      function page() { return Math.max(car.clientWidth - 8, 100); }
      function update() {
        var atStart = car.scrollLeft <= 4;
        var atEnd = car.scrollLeft + car.clientWidth >= car.scrollWidth - 4;
        if (prev) { prev.style.opacity = atStart ? '0' : '1'; prev.style.pointerEvents = atStart ? 'none' : 'auto'; }
        if (next) { next.style.opacity = atEnd ? '0' : '1'; next.style.pointerEvents = atEnd ? 'none' : 'auto'; }
      }
      if (next) next.addEventListener('click', function () { car.scrollBy({ left: page(), behavior: 'smooth' }); });
      if (prev) prev.addEventListener('click', function () { car.scrollBy({ left: -page(), behavior: 'smooth' }); });
      car.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
          window.scrollBy(0, e.deltaY);
          e.preventDefault();
        }
      }, { passive: false });
      car.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHcpArrows);
  } else {
    initHcpArrows();
  }
})();
